const actions = {
  initializePermissions({ commit }, permissions) {
    commit('setPermissions', permissions);
  },
  grantPermission({ commit }, { key, value }) {
    commit('addPermission', { key, value });
  },
};

export default actions;
